import { useSocket } from "@/contexts/SocketContext.tsx";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";

/**
 * Refetches the current user when whether Okthx can text them changes — a
 * refusal, an opt-out, or the text from them that lifts it — so the Text
 * Messages connector and its banner update without a reload. Mount once at
 * the app level.
 */
export const useTextMessagesChangedSocket = () => {
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  const refetchUser = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ["currentUser"] });
  }, [queryClient]);

  useEffect(() => {
    if (!socket) return;

    // A one-shot emit with no replay, lost while this client was disconnected,
    // so refetch on every (re)connect and then listen live.
    refetchUser();
    socket.on("account:text_messages_changed", refetchUser);
    return () => {
      socket.off("account:text_messages_changed", refetchUser);
    };
  }, [socket, refetchUser]);
};
